"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getValidationMessageForElement = function getValidationMessageForElement(elementA) {
  return elementA && elementA instanceof HTMLElement ? elementA.validationMessage : "";
};

var _default = getValidationMessageForElement;
exports.default = _default;